/**
 *Created by jmmartinez on 12/03/2020
 *  v.1.0 1/04/2020
 *  v.2.0 30/09/2020 Cambiado a framework2
 *  v.2.1 08/10/2020 Añadido método getDerivedStateFromProps
 *  **/

import React from 'react'
import {Checkbox, FormGroup, InputGroup} from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import "../../resources/css/datetimeactivable.css"
import PropTypes from 'prop-types';

import {esTimestampMayorQueMin, getMinDate} from "../utils/DateUtils";
import DateTimeInput from "../../blueprint/DateTimeInput";


class DateTimeActivable extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            fecha: props.fecha,
            activo: esTimestampMayorQueMin(props.fecha) ? true : false,
        }
        this.ref = React.createRef();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.fecha !== prevState.fecha) {
            newState.fecha = nextProps.fecha;
            newState.activo= esTimestampMayorQueMin(nextProps.fecha) ? true : false;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onChange= (newFecha) => {
        //console.log("onChange");
        //console.log(getFormattedDateTimeFromTimestamp(newFecha));
        const {onChange} = this.props;
        onChange && onChange(newFecha);
    }

    changeFecha= (fecha) =>{
        let activo= esTimestampMayorQueMin(fecha) ? true : false;
        this.setState({fecha: fecha, activo: activo}, this.onChange(fecha));
    }

    changeActivo= (checked) => {
        let newFecha= checked ? new Date().getTime() : getMinDate().getTime();
        this.setState({fecha: newFecha, activo: checked}, this.onChange(newFecha));
    }

    renderPorDivs() {
        const { fecha, activo} = this.state;
        const {index, titulo, campo, obligatorio, conHora} = this.props;

        return (
            <div className="datetimeactivable">
                <div className="titulo">{titulo}</div>
                <div className="elementos">
                    <Checkbox checked={activo} onChange={ (event) => this.changeActivo(event.target.checked) } />
                    {activo &&
                    <DateTimeInput conHora={conHora} valor={fecha} obligatorio={obligatorio}
                                   onChange={this.changeFecha}/>
                    }
                </div>
            </div>
        );
    }

    render() {
        const { fecha, activo} = this.state;
        const {index, titulo, campo, obligatorio, conHora} = this.props;

        return (
            <FormGroup key={index} label= {titulo} labelFor={campo} labelInfo={ obligatorio ? "*" : ""}>
                <div style={{display: 'flex'}}>
                    <Checkbox checked={activo} onChange={ (event) => this.changeActivo(event.target.checked) } />
                    {activo &&
                    <DateTimeInput conHora={conHora} valor={fecha} obligatorio={obligatorio}
                                   onChange={this.changeFecha}/>
                    }
                    {!activo &&
                    <div style={{textAlign: 'center', marginTop:'6px'}}> FECHA INACTIVA </div>
                    }
                </div>
            </FormGroup>
        );
    }
}

DateTimeActivable.propTypes = {
    fecha: PropTypes.number,
    index: PropTypes.any,
    titulo: PropTypes.string,
    campo: PropTypes.string,
    obligatorio: PropTypes.bool,
    conHora: PropTypes.bool,
    onChange: PropTypes.func,
}

export default DateTimeActivable

